import React from "react";
import { cn } from "@/lib/utils";

export interface FullWidthDropdownProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  timersRef?: React.MutableRefObject<ReturnType<typeof setTimeout> | null>;
  topOffsetClass?: string; // e.g., top-[65px]
  bgClassName?: string; // e.g., bg-[#00254990] text-white backdrop-blur-md shadow-2xl border border-transparent
  panelClassName?: string; // e.g., px-8 py-6
  innerClassName?: string; // width wrapper for inner content
  triggerClassName?: string; // classes for the trigger button
  children: React.ReactNode; // trigger content (label + chevron)
  panel: React.ReactNode; // inner panel content (grid, links, etc.)
}

export const FullWidthDropdown: React.FC<FullWidthDropdownProps> = ({
  open,
  setOpen,
  timersRef,
  topOffsetClass,
  bgClassName = "bg-[#0F2030]/80 text-white backdrop-blur-sm rounded-lg",
  panelClassName = "px-3 py-2",
  innerClassName = "w-max px-3 py-2",
  triggerClassName,
  children,
  panel,
}) => {
  return (
    <div className="relative">
      <button
        className={cn(
          // base trigger styles (can be overridden/extended)
          "inline-flex items-center px-2 py-1.5 text-sm font-medium transition-all duration-300 cursor-pointer gap-1.5 hover:bg-white/10 hover:scale-105 rounded-md",
          triggerClassName
        )}
        type="button"
        onClick={() => setOpen(!open)}
        onMouseEnter={() => {
          if (timersRef?.current) clearTimeout(timersRef.current);
          setOpen(true);
        }}
        onMouseLeave={() => {
          if (timersRef) timersRef.current = setTimeout(() => setOpen(false), 250);
        }}
      >
        {children}
      </button>

      {open && (
        <div
          className={cn(
            "absolute z-[99]",
            topOffsetClass,
            bgClassName,
            panelClassName
          )}
          onMouseEnter={() => {
            if (timersRef?.current) clearTimeout(timersRef.current);
            setOpen(true);
          }}
          onMouseLeave={() => {
            if (timersRef) timersRef.current = setTimeout(() => setOpen(false), 250);
          }}
        >
          <div className={cn(innerClassName)}>{panel}</div>
        </div>
      )}
    </div>
  );
};
